import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class InvoiceEstimatesService extends AbstractService {
	static endpoint = ENDPOINTS.jobEstimates;

	static getAll({ getCancelToken, ...rest }) {
		return this.get({
			endpoint: this.endpoint,
			queryParams: rest,
			getCancelToken,
		});
	}

	static getCounts({ getCancelToken, ...rest }) {
		return this.get({
			endpoint: `${this.endpoint}/${ENDPOINTS.counts}`,
			queryParams: rest,
			getCancelToken,
		});
	}

	static getInvoiceEstimateFromId(id, getCancelToken) {
		return this.get({
			getCancelToken,
			endpoint: this.endpoint,
			queryParams: { invoiceEstimateId: id },
		});
	}

	static getInvoiceEstimatePDFFromId(id) {
		return this.get({
			endpoint: `${this.endpoint}/pdf`,
			queryParams: { invoiceEstimateId: id },
			responseType: "blob",
		});
	}

	static resend(id) {
		return this.post({
			endpoint: `${this.endpoint}/${id}/resend`,
		});
	}
}
